(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[913],{

/***/ 46259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ scrollToBottomHeader; }
/* harmony export */ });
var scrollToBottomHeader = function scrollToBottomHeader(el) {
  var headerHeight = 38 + 66 + 6; // 38 is search bar height
  // 66 is header bar height
  // 6 is space between header and element to get perfect view

  window.scrollTo({
    top: el.getBoundingClientRect().top + window.pageYOffset - headerHeight,
    behavior: "smooth"
  });
};

/***/ }),

/***/ 27476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FaCheck; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheck(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 16091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91164);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/** Vendors **/

/** Components **/

/** ========== **/

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */



var TawkToButton = function TawkToButton(_ref) {
  var children = _ref.children,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    onClick: /*#__PURE__*/(0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Tawk_API.toggle();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  }, props), {}, {
    children: children || "Talk To Our Expert Now"
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (TawkToButton);

/***/ }),

/***/ 30913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_PackagesNews; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(40037);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/action-function/scrollToBottomHeader.js
var scrollToBottomHeader = __webpack_require__(46259);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./common/priceConvert.js
var common_priceConvert = __webpack_require__(46518);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheck.js
var FaCheck = __webpack_require__(27476);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/TawkToButton/index.js
var TawkToButton = __webpack_require__(16091);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/templates/common/post/FormDownloadModal/index.js
var FormDownloadModal = __webpack_require__(53693);
// EXTERNAL MODULE: ./components/molecules/CardPackage/Index.module.scss
var Index_module = __webpack_require__(67148);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/CardPackage/index.js








var PackageModal = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9885), __webpack_require__.e(7258), __webpack_require__.e(1183)]).then(__webpack_require__.bind(__webpack_require__, 87258));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(87258)];
    },
    modules: ["../components/molecules/CardPackage/index.js -> " + "components/molecules/PackageModal"]
  }
});

/** ========== */





var CardPackage = function CardPackage(_ref) {
  var kind = _ref.kind,
      price = _ref.price,
      changePrice = _ref.changePrice,
      data = _ref.data,
      dataSuffix = _ref.dataSuffix,
      index = _ref.index,
      linkRegister = _ref.linkRegister,
      subPrice = _ref.subPrice,
      sale_off = _ref.sale_off,
      pauseRegister = _ref.pauseRegister,
      customCardColor = _ref.customCardColor;

  var getKindClass = function getKindClass() {
    if (customCardColor) {
      if (index == 0) return customCardColor.text[0];
      if (index == 1) return customCardColor.text[1];
      if (index == 2) return customCardColor.text[2];
    } else {
      if (index == 0) return "text-bbc-brand-500";
      if (index == 1) return "text-bbc-yellow-500";
      if (index == 2) return "text-bbc-brand-700";
    }
  };

  var borderColorClass = function borderColorClass() {
    if (customCardColor) {
      if (index == 0) return customCardColor.border[0];
      if (index == 1) return customCardColor.border[1];
      if (index == 2) return customCardColor.border[2];
    } else {
      if (index == 0) return "lg:hover:border-bbc-brand-500";
      if (index == 1) return "lg:hover:border-bbc-yellow-500";
      if (index == 2) return "lg:hover:border-bbc-brand-700";
    }
  };

  var btnColorClass = function btnColorClass() {
    if (customCardColor) {
      if (index == 0) return customCardColor.button[0];
      if (index == 1) return customCardColor.button[1];
      if (index == 2) return customCardColor.button[2];
    } else {
      if (index == 0) return "bg-bbc-brand-500  ".concat((Index_module_default()).btnBlue, " ");
      if (index == 1) return "bg-bbc-yellow-500  ".concat((Index_module_default()).btnYellow);
      if (index == 2) return "bg-bbc-brand-700 ".concat((Index_module_default()).btnDarkBlue);
    }
  };

  var _ref2 = data || [],
      content = _ref2.content,
      notes = _ref2.notes,
      banner = _ref2.banner,
      bannerLink = _ref2.bannerLink,
      banner_width = _ref2.banner_width,
      banner_height = _ref2.banner_height,
      dataForm = _ref2.dataForm;

  var _useState = (0,react.useState)(false),
      modalShow = _useState[0],
      setModalShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showFormDownload = _useState2[0],
      setShowFormDownload = _useState2[1];

  var showEbookBookModal = function showEbookBookModal() {
    setShowFormDownload(true);
  };

  var GetPrice = function GetPrice(_ref3) {
    var priceConvert = _ref3.priceConvert,
        unitChange = _ref3.unitChange;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: changePrice ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,common_priceConvert/* AutoConvertPriceWithUnit */.Nd)(priceConvert, unitChange || 1)
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: unitChange || "US$"
        }), priceConvert]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      maxWidth: "350px"
    },
    className: "".concat(borderColorClass(), " group relative m-auto flex h-full flex-col justify-between rounded-3xl  border-0 border-transparent bg-white ring-1 ring-neutral-200 transition-all duration-200 hover:ring-transparent lg:border-4 lg:hover:border-4 lg:hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        zIndex: "2",
        backgroundColor: "white",
        borderRadius: "24px"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          paddingTop: "29px"
        },
        className: "border-b border-b-bbc-neutral-500 px-5  pb-8 text-center ".concat(getKindClass(index)),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          style: {
            fontSize: "32px",
            lineHeight: "42px",
            letterSpacing: "0.25px"
          },
          className: "mb-8 font-semibold uppercase",
          children: kind
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            fontSize: "50px",
            lineHeight: "54px",
            letterSpacing: "0.25px"
          },
          className: "flex items-center justify-center font-semibold lg:flex-wrap xl:flex-nowrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat(subPrice && "mr-2", " inline-block"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(GetPrice, {
              priceConvert: price
            })
          }), subPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "inline-block text-2xl font-semibold text-bbc-brand-900",
            dangerouslySetInnerHTML: {
              __html: subPrice
            }
          })]
        }), sale_off && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-2 text-2xl font-medium text-bbc-neutral-700",
          children: ["Save ", /*#__PURE__*/(0,jsx_runtime.jsx)(GetPrice, {
            priceConvert: sale_off
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "py-8 px-5",
        children: [(content === null || content === void 0 ? void 0 : content.length) > 0 && content.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [item.preTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "relative mt-2 flex font-semibold first:mt-0",
              dangerouslySetInnerHTML: {
                __html: item.preTitle
              }
            }), item.subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "relative mt-2 flex pl-4 font-semibold before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-[''] first:mt-0",
              dangerouslySetInnerHTML: {
                __html: item.subTitle
              }
            }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-2",
              dangerouslySetInnerHTML: {
                __html: item.description
              }
            }), (item === null || item === void 0 ? void 0 : item.listContent) && (item === null || item === void 0 ? void 0 : item.listContent.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: "pl-0.5",
              children: item.listContent.map(function (content, key) {
                return content.checkName || content.ebook_download ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [content.checkName && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
                      children: modalShow && /*#__PURE__*/(0,jsx_runtime.jsx)(PackageModal, {
                        country_name: dataSuffix.name,
                        country_id: dataSuffix.id,
                        show: modalShow,
                        onHide: function onHide() {
                          return setModalShow(false);
                        },
                        suffix_data: dataSuffix.suffixData
                      })
                    })
                  }), content.ebook_download && /*#__PURE__*/(0,jsx_runtime.jsx)(FormDownloadModal["default"], {
                    show: showFormDownload,
                    onHide: function onHide() {
                      return setShowFormDownload(false);
                    },
                    typeFormDownload: "checklist_delaware"
                  }), content.dataForm ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mt-2 cursor-pointer",
                    onClick: function onClick() {
                      content.checkName ? setModalShow(true) : content.ebook_download && setShowFormDownload(true);
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute top-1.5 left-0 text-bbc-brand-500",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      className: "btn inline-block pl-7 font-medium text-bbc-primary ",
                      dangerouslySetInnerHTML: {
                        __html: content.text
                      }
                    }), content.childContent && content.childContent.map(function (item1, index1) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "inline-block pl-7 font-medium text-bbc-primary",
                          dangerouslySetInnerHTML: {
                            __html: item1
                          }
                        })
                      }, index1);
                    })]
                  }, key) : /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mt-2 cursor-pointer",
                    id: content.hash_id && content.hash_id,
                    onClick: function onClick() {
                      content.checkName ? setModalShow(true) : content.ebook_download && showEbookBookModal(content.hash_id);
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute top-1.5 left-0 text-bbc-brand-500",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7 font-medium text-bbc-primary ",
                      dangerouslySetInnerHTML: {
                        __html: content.text
                      }
                    }), content.childContent && content.childContent.map(function (item1, index1) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "inline-block pl-7 font-medium text-bbc-primary",
                          dangerouslySetInnerHTML: {
                            __html: item1
                          }
                        })
                      }, index1);
                    })]
                  }, key)]
                }, key) : /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: "relative mt-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                    className: "absolute top-1.5 left-0 text-bbc-brand-500",
                    size: 12
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "inline-block pl-7",
                    dangerouslySetInnerHTML: {
                      __html: content.text
                    }
                  }), content.childContent && content.childContent.map(function (item1, index1) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      className: "ml-12 list-disc ",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                          __html: item1
                        }
                      })
                    }, index1);
                  })]
                }, key);
              })
            })]
          }, index);
        }), (notes === null || notes === void 0 ? void 0 : notes.length) > 0 && notes.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("em", {
            className: "mt-2 block text-sm leading-6",
            dangerouslySetInnerHTML: {
              __html: item
            }
          }, index);
        }), banner && (bannerLink && bannerLink.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: dataForm ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            id: "shortcode_download_form",
            className: "mt-10 rounded-xl bg-bbc-brand-800 px-5 pt-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "pb-2 text-center font-semibold text-bbc-white",
              children: "Not sure which banks suit you? Try our all-inclusive banking guideline!"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative pt-4",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                className: "mx-auto  h-auto w-fit cursor-pointer",
                src: "/assets/images/offshore/country/delaware/ebook_redirect-delaware-book.png",
                alt: "package banner",
                width: 788,
                height: 763,
                wrapper: {
                  className: "w-full "
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 w-full text-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  onClick: function onClick() {
                    return setShowFormDownload(true);
                  },
                  className: "pl-3",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    className: " h-auto w-fit cursor-pointer transition-transform duration-150 hover:scale-105",
                    src: "/assets/images/offshore/country/delaware/ebook_redirect-delaware-download-btn.png",
                    alt: "package banner",
                    width: 186,
                    height: 77
                  })
                })
              })]
            }), dataForm && /*#__PURE__*/(0,jsx_runtime.jsx)(FormDownloadModal["default"], {
              show: showFormDownload,
              onHide: function onHide() {
                return setShowFormDownload(false);
              },
              typeFormDownload: "banking_guide"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: bannerLink,
            rel: "nofollow",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              className: "mx-auto mt-6 h-auto w-fit cursor-pointer",
              src: banner,
              alt: "package banner",
              width: banner_width || 300,
              height: banner_height || 192,
              wrapper: {
                className: "w-full "
              }
            })
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          className: "mx-auto mt-6 h-auto w-fit",
          src: banner,
          alt: "package banner",
          width: banner_width || 300,
          height: banner_height || 192,
          wrapper: {
            className: "w-full "
          }
        }))]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "border-t border-t-bbc-neutral-500 px-5 pt-8 pb-11 text-center",
      children: pauseRegister ?
      /*#__PURE__*/
      // <LinkRouter
      //   Href={"/contact-us"}
      //   ClassName="inline-block w-full cursor-pointer rounded-full border py-2 px-6 font-normal text-bbc-brand-500 hover:bg-bbc-brand-600 group-hover:bg-bbc-brand-500 group-hover:!font-medium group-hover:text-white"
      // >
      //   Contact Us
      // </LinkRouter>
      (0,jsx_runtime.jsx)(TawkToButton/* default */.Z, {
        className: "inline-block w-full cursor-pointer rounded-full  py-2 px-6 font-medium text-bbc-white ".concat((Index_module_default()).btnAnimate, " ").concat(btnColorClass(), " "),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "Chat With Us"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: linkRegister,
        className: "inline-block w-full cursor-pointer rounded-full  py-2 px-6 font-medium text-bbc-white ".concat((Index_module_default()).btnAnimate, " ").concat(btnColorClass(), " "),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "Get Started"
        })
      })
    })]
  });
};

/* harmony default export */ var molecules_CardPackage = (CardPackage);
CardPackage.defaultProps = {
  notes: [],
  content: [],
  index: 0
};
/** ========== */
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
;// CONCATENATED MODULE: ./components/organisms/PackagesNews/index.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react-hooks/exhaustive-deps */






/** ========== */




var PackagesNews = function PackagesNews(_ref) {
  var _data$entitySuffix, _dataEntitySuffix$, _data$entitySuffix2, _data$packages, _data$packages$Packag, _data$entitySuffix3, _data$entitySuffix3$E;

  var data = _ref.data,
      dataStatic = _ref.dataStatic,
      title = _ref.title,
      changePrice = _ref.changePrice,
      tabBarClass = _ref.tabBarClass,
      customCardColor = _ref.customCardColor,
      note = _ref.note,
      subFeeArr = _ref.subFeeArr;
  var dataEntitySuffix = data === null || data === void 0 ? void 0 : (_data$entitySuffix = data.entitySuffix) === null || _data$entitySuffix === void 0 ? void 0 : _data$entitySuffix.EntityTypes;
  var dataStaticPackage = dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.listPackage;

  var _useState = (0,react.useState)(0),
      defaultTab = _useState[0],
      setDefaultTab = _useState[1];

  var temp = dataEntitySuffix === null || dataEntitySuffix === void 0 ? void 0 : dataEntitySuffix.reduce(function (totalID, currentValue) {
    totalID.push("".concat(currentValue.guid, "-package"));
    return totalID;
  }, []);

  var dataStaticFilter = function dataStaticFilter(id) {
    var result = dataStaticPackage.find(function (fruit) {
      return fruit.id == id;
    });
    return result;
  };

  var dataLink = "".concat((_dataEntitySuffix$ = dataEntitySuffix[0]) === null || _dataEntitySuffix$ === void 0 ? void 0 : _dataEntitySuffix$.guid, "-package");
  (0,react.useEffect)(function () {
    if (dataLink.length > 0) {
      var url = window.location.href;
      setDefaultTab(temp.indexOf(url.split("#")[1]) < 0 ? 0 : temp.indexOf(url.split("#")[1]));

      if (url.search("#".concat(url.split("#")[1])) > 0) {
        var scrollToTable = document.getElementById("PriceTable");
        (0,scrollToBottomHeader/* scrollToBottomHeader */.A)(scrollToTable);
      }
    }
  }, []);
  (0,react.useEffect)(function () {
    if (dataLink.length == 0) {
      setDefaultTab(0);
    }
  }, []);

  function caseInTotal(condition, store, value) {
    switch (condition) {
      case "add":
        return store + value;

      case "minus":
        return store - value;

      case "div":
        return store / value;

      case "multi":
        return store * value;

      default:
        return store;
    }
  }

  function calculateSubFee(data) {
    var totalFee = 0;

    var additionalServices = (0,toConsumableArray/* default */.Z)(data.AdditionalServices);

    if (subFeeArr && subFeeArr.length > 0) {
      var clone_sub_fee_arr = (0,toConsumableArray/* default */.Z)(subFeeArr);

      var _loop = function _loop(index) {
        var element = clone_sub_fee_arr[index];

        if (element.entity_type_id === data.entity_type_id) {
          var elementConditionTotal = additionalServices.reduce(function (store, current) {
            if (current.id === element.id) {
              return caseInTotal(element.type, store, current.Fee.value);
            }

            return store;
          }, totalFee);
          totalFee = elementConditionTotal;
        }
      };

      for (var index = 0; index < clone_sub_fee_arr.length; index++) {
        _loop(index);
      }
    }

    return totalFee;
  }

  var checkLengthContent = dataEntitySuffix === null || dataEntitySuffix === void 0 ? void 0 : dataEntitySuffix.map(function (item) {
    return item.name;
  }).join(" ").length;
  var countryId = data === null || data === void 0 ? void 0 : (_data$entitySuffix2 = data.entitySuffix) === null || _data$entitySuffix2 === void 0 ? void 0 : _data$entitySuffix2.id;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    id: "PriceTable",
    className: "min-h-screen",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
      text: title,
      className: "bbc-title text-center ".concat(dataStatic !== null && dataStatic !== void 0 && dataStatic.description && dataStatic !== null && dataStatic !== void 0 && dataStatic.description.length ? " mb-6" : " mb-6 lg:mb-10")
    }), (dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.description) && (dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.description.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "m-auto mb-6 w-4/5 text-center lg:mb-10",
      children: dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
        activeTab: defaultTab,
        data: dataEntitySuffix === null || dataEntitySuffix === void 0 ? void 0 : dataEntitySuffix.map(function (item) {
          return item.name;
        }),
        tabLinks: dataEntitySuffix === null || dataEntitySuffix === void 0 ? void 0 : dataEntitySuffix.map(function (item) {
          return "".concat(item.guid, "-package");
        }),
        tabListClass: data !== null && data !== void 0 && (_data$packages = data.packages) !== null && _data$packages !== void 0 && (_data$packages$Packag = _data$packages.Packages) !== null && _data$packages$Packag !== void 0 && _data$packages$Packag.every(function (item) {
          return item.entity_type_id === null;
        }) ? {
          display: "hidden"
        } : _objectSpread(_objectSpread({}, checkLengthContent > 30 && {
          display: "block md:flex justify-center",
          border: "border-0 md:border border-bbc-neutral-600",
          background: "bg-transparent md:bg-white"
        }), {}, {
          othersClass: "md:whitespace-nowrap ".concat(tabBarClass)
        }),
        tabClass: _objectSpread({
          tabColor: " text-bbc-neutral-600 hover:text-bbc-brand-500 border-bbc-neutral-600 md:border-transparent mx-auto",
          tabColorActive: "text-bbc-brand-500 border-bbc-brand-500 bg-white"
        }, checkLengthContent > 30 && {
          othersClass: "my-1 md:my-0  mx-auto"
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
          className: "mt-6 w-full ",
          children: data === null || data === void 0 ? void 0 : (_data$entitySuffix3 = data.entitySuffix) === null || _data$entitySuffix3 === void 0 ? void 0 : (_data$entitySuffix3$E = _data$entitySuffix3.EntityTypes) === null || _data$entitySuffix3$E === void 0 ? void 0 : _data$entitySuffix3$E.map(function (entity, indexEntity) {
            var _data$packages2, _data$packages2$Packa, _data$packages3, _data$packages4, _dataStatic$listPacka;

            var dataPackages = data !== null && data !== void 0 && (_data$packages2 = data.packages) !== null && _data$packages2 !== void 0 && (_data$packages2$Packa = _data$packages2.Packages) !== null && _data$packages2$Packa !== void 0 && _data$packages2$Packa.every(function (item) {
              return item.entity_type_id === null;
            }) ? data === null || data === void 0 ? void 0 : (_data$packages3 = data.packages) === null || _data$packages3 === void 0 ? void 0 : _data$packages3.Packages : data === null || data === void 0 ? void 0 : (_data$packages4 = data.packages) === null || _data$packages4 === void 0 ? void 0 : _data$packages4.Packages.filter(function (item) {
              return item.entity_type_id == entity.id;
            });
            var checkContentLengthMobile = (dataPackages === null || dataPackages === void 0 ? void 0 : dataPackages.map(function (card) {
              var _card$PackageType;

              return card === null || card === void 0 ? void 0 : (_card$PackageType = card.PackageType) === null || _card$PackageType === void 0 ? void 0 : _card$PackageType.name.split(" ").join("");
            }).join("").length) > 30;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
              className: "focus:outline-none focus:outline-0 focus:ring-0 ".concat((_dataStatic$listPacka = dataStatic.listPackage) !== null && _dataStatic$listPacka !== void 0 && _dataStatic$listPacka.find(function (el) {
                return (el === null || el === void 0 ? void 0 : el.kind) == "standard";
              }) ? "lg:mt-20" : ""),
              as: "div",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "row justify-center",
                  children: dataPackages === null || dataPackages === void 0 ? void 0 : dataPackages.map(function (card, index) {
                    var _card$PackageType2, _data$entitySuffix4, _data$entitySuffix5;

                    var price = card === null || card === void 0 ? void 0 : card.Services.reduce(function (sum, item) {
                      var _item$Fee;

                      return sum + (item === null || item === void 0 ? void 0 : (_item$Fee = item.Fee) === null || _item$Fee === void 0 ? void 0 : _item$Fee.value);
                    }, 0);
                    var discount = card === null || card === void 0 ? void 0 : card.Services.reduce(function (sum, item) {
                      if (item.service_type_id === 49) {
                        var _item$Fee2;

                        return sum + (item === null || item === void 0 ? void 0 : (_item$Fee2 = item.Fee) === null || _item$Fee2 === void 0 ? void 0 : _item$Fee2.value);
                      }

                      return sum;
                    }, 0);
                    var subFee = calculateSubFee(card);
                    var title = card === null || card === void 0 ? void 0 : (_card$PackageType2 = card.PackageType) === null || _card$PackageType2 === void 0 ? void 0 : _card$PackageType2.name;
                    var itemStatic = dataStatic.listPackage[index];
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "relative lg:col-4",
                      children: [itemStatic.best_seller && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "absolute -top-10 left-0 right-0 z-0 px-[15px]",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: " mx-auto h-20 w-full rounded-t-[24px] bg-bbc-yellow-500  pt-1 text-center text-2xl font-semibold capitalize text-bbc-white",
                          children: itemStatic.seller_content || "Best Seller"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_CardPackage, _objectSpread(_objectSpread(_objectSpread({}, itemStatic), {}, {
                        kind: title,
                        changePrice: changePrice,
                        price: price + subFee,
                        data: dataStaticFilter(card.id)
                      }, discount != 0 && {
                        sale_off: Math.abs(discount)
                      }), {}, {
                        dataSuffix: {
                          id: countryId,
                          name: (_data$entitySuffix4 = data.entitySuffix) === null || _data$entitySuffix4 === void 0 ? void 0 : _data$entitySuffix4.sub_name,
                          suffixData: data === null || data === void 0 ? void 0 : (_data$entitySuffix5 = data.entitySuffix) === null || _data$entitySuffix5 === void 0 ? void 0 : _data$entitySuffix5.EntityTypes[indexEntity]
                        },
                        index: index,
                        customCardColor: customCardColor,
                        linkRegister: "/onboarding/register?country_id=".concat(countryId, "&entity_type_id=").concat(entity === null || entity === void 0 ? void 0 : entity.id, "&package_id=").concat(card.id)
                      }))]
                    }, index);
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "block w-full lg:hidden",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
                  data: dataPackages.map(function (card) {
                    var _card$PackageType3;

                    return card === null || card === void 0 ? void 0 : (_card$PackageType3 = card.PackageType) === null || _card$PackageType3 === void 0 ? void 0 : _card$PackageType3.name;
                  }).filter(function (item) {
                    return item;
                  }),
                  tabListClass: checkContentLengthMobile ? {
                    display: "flex flex-col items-center",
                    border: "border-0"
                  } : {
                    background: "bg-white"
                  },
                  tabClass: checkContentLengthMobile ? {
                    tabColorActive: "bg-white border-bbc-brand-500 text-bbc-brand-500 my-0.5",
                    tabColor: "bg-white border text-bbc-neutral-600 my-0.5"
                  } : {
                    padding: "py-3 px-4 sm:py-3 sm:px-6"
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
                    className: "mt-6 w-full",
                    children: dataPackages === null || dataPackages === void 0 ? void 0 : dataPackages.map(function (card, index) {
                      var _card$PackageType4, _data$entitySuffix6, _data$entitySuffix7;

                      var price = card === null || card === void 0 ? void 0 : card.Services.reduce(function (sum, item) {
                        var _item$Fee3;

                        return sum + (item === null || item === void 0 ? void 0 : (_item$Fee3 = item.Fee) === null || _item$Fee3 === void 0 ? void 0 : _item$Fee3.value);
                      }, 0);
                      var subFee = calculateSubFee(card);
                      var title = card === null || card === void 0 ? void 0 : (_card$PackageType4 = card.PackageType) === null || _card$PackageType4 === void 0 ? void 0 : _card$PackageType4.name;
                      var itemStatic = dataStatic.listPackage[index];
                      var discount = card === null || card === void 0 ? void 0 : card.Services.reduce(function (sum, item) {
                        if (item.service_type_id === 49) {
                          var _item$Fee4;

                          return sum + (item === null || item === void 0 ? void 0 : (_item$Fee4 = item.Fee) === null || _item$Fee4 === void 0 ? void 0 : _item$Fee4.value);
                        }

                        return sum;
                      }, 0);
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                        className: "".concat(itemStatic.best_seller ? "mt-16" : "", " relative focus:outline-none focus:outline-0 focus:ring-0"),
                        as: "div",
                        children: [itemStatic.best_seller && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          style: {
                            maxWidth: "350px"
                          },
                          className: "absolute -top-10 left-0 right-0 z-0 mx-auto h-20 w-full rounded-t-[24px] bg-bbc-yellow-500  pt-1 text-center text-2xl font-semibold capitalize text-bbc-white",
                          children: itemStatic.seller_content || "Best Seller"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_CardPackage, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, itemStatic), {}, {
                          kind: title,
                          price: price + subFee,
                          data: dataStaticFilter(card.id)
                        }, discount != 0 && {
                          sale_off: Math.abs(discount)
                        }), discount != 0 && {
                          sale_off: Math.abs(discount)
                        }), {}, {
                          index: index,
                          customCardColor: customCardColor,
                          changePrice: changePrice,
                          dataSuffix: {
                            id: countryId,
                            name: (_data$entitySuffix6 = data.entitySuffix) === null || _data$entitySuffix6 === void 0 ? void 0 : _data$entitySuffix6.sub_name,
                            suffixData: (_data$entitySuffix7 = data.entitySuffix) === null || _data$entitySuffix7 === void 0 ? void 0 : _data$entitySuffix7.EntityTypes[index]
                          },
                          linkRegister: "/onboarding/register?country_id=".concat(countryId, "&entity_type_id=").concat(entity === null || entity === void 0 ? void 0 : entity.id, "&package_id=").concat(card.id)
                        }))]
                      }, index);
                    })
                  })
                })
              })]
            }, indexEntity);
          })
        })
      })
    }), note && /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
      className: "mt-6 block rounded-2xl bg-[#F5F5F5] px-4 py-6 lg:mt-10 lg:px-10",
      dangerouslySetInnerHTML: {
        __html: note
      }
    })]
  });
};

/* harmony default export */ var organisms_PackagesNews = (PackagesNews);

/***/ }),

/***/ 53693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/**
 * Vendor
 */

/**
 * Components
 */




var FormDownload = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_0__["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9885), __webpack_require__.e(9669), __webpack_require__.e(7445)]).then(__webpack_require__.bind(__webpack_require__, 37445));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37445)];
    },
    modules: ["../components/templates/common/post/FormDownloadModal/index.js -> " + "./FormDownload"]
  }
});

var FormDownloadModal = function FormDownloadModal(_ref) {
  var descriptionClass = _ref.descriptionClass,
      checkboxTextClassName = _ref.checkboxTextClassName,
      show = _ref.show,
      onHide = _ref.onHide,
      typeFormDownload = _ref.typeFormDownload;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: show && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FormDownload, {
        descriptionClass: descriptionClass,
        checkboxTextClassName: checkboxTextClassName,
        show: show,
        onHide: onHide,
        typeFormDownload: typeFormDownload
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FormDownloadModal);
/** ========== */

/***/ }),

/***/ 67148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnAnimate":"Index_btnAnimate__9QWo4","btnBlue":"Index_btnBlue__R4E_L","btnYellow":"Index_btnYellow__dEMtU","btnDarkBlue":"Index_btnDarkBlue__bbUcz"};

/***/ })

}]);